import React, { useState } from 'react';
import FilterBar from './FilterBar';
const SearchAndFilters = ({ showAllResources, setShowAllResources }) => {
    const [sortMenuOpen, setSortMenuOpen] = useState(false);
    const [sortOption, setSortOption] = useState('Default');
    const sortOptions = [
        'Default',
        'Name A-Z',
        'Name Z-A',
        'Availability',
        'Capacity (Low to High)',
        'Capacity (High to Low)'
    ];
    const toggleSortMenu = () => {
        setSortMenuOpen(!sortMenuOpen);
    };
    const handleSortSelect = (option) => {
        setSortOption(option);
        setSortMenuOpen(false);
    };
    return (React.createElement("div", { className: "bg-white p-4 border-b rounded-t-md shadow-sm" },
        React.createElement(FilterBar, null),
        React.createElement("div", { className: "flex justify-between items-center mt-3" },
            React.createElement("div", { className: "flex items-center" },
                React.createElement("input", { type: "checkbox", id: "showAll", className: "mr-2 h-4 w-4 text-blue-600 rounded", checked: showAllResources, onChange: () => setShowAllResources(!showAllResources) }),
                React.createElement("label", { htmlFor: "showAll", className: "text-sm text-gray-600" }, "Only list available resources")),
            React.createElement("div", { className: "relative" },
                React.createElement("button", { className: "flex items-center text-blue-600", onClick: toggleSortMenu },
                    React.createElement("span", { className: "text-sm font-medium mr-1" }, "Sort By"),
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: sortMenuOpen ? "M5 15l7-7 7 7" : "M8 9l4-4 4 4m0 6l-4 4-4-4" }))),
                sortMenuOpen && (React.createElement("div", { className: "absolute right-0 mt-1 w-56 bg-white border rounded-md shadow-lg z-20" }, sortOptions.map((option, index) => (React.createElement("div", { key: index, className: `p-2 hover:bg-gray-100 cursor-pointer text-sm ${option === sortOption ? 'bg-blue-50 text-blue-600' : ''}`, onClick: () => handleSortSelect(option) }, option)))))))));
};
export default SearchAndFilters;
